import BaseComponent from './BaseComponent';

class GuidanceList extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;

        this.el.querySelector('.title-list-back').addEventListener('click', (e) => {
            e.preventDefault();
            e.target.style.display = 'none';
            history.pushState(null, null, ' ');
            this.el.querySelectorAll('.title-list__item, .title-list__item__body').forEach((list) => {
                if (list.classList.contains('title-list__item')) {
                    list.style.display = '';
                } else {
                    list.style.display = 'none';
                }
            });
        });

        this.el.querySelectorAll('.title-list__item .title-list__item__head').forEach((list) => {
            list.addEventListener('click', (e) => {
                e.preventDefault();
                if (list.parentNode.classList.contains('in-backend')) {
                    return;
                }
                history.pushState(true, '', '#' + list.querySelector('h3').id);
                list.parentNode.querySelector('.title-list__item__body').style.display = '';
                this.el.querySelector('.title-list-back').style.display = 'block';
                this.el.querySelectorAll('.title-list__item .title-list__item__head').forEach((otherList) => {
                    if (list !== otherList) {
                        otherList.parentNode.style.display = 'none';
                    }
                });
            });
        });

        let hash =  window.location.hash ? el.querySelector(decodeURI(window.location.hash)) : null;
        if (hash) {
            this.el.querySelector('.title-list-back').style.display = 'block';
            this.el.querySelectorAll('.title-list__item .title-list__item__head').forEach((otherList) => {
                otherList.parentNode.style.display = 'none';
            });
            let element = hash.closest('.title-list__item__body');
            if (element) {
                element.style.display = 'block';
                element.parentNode.style.display = 'block';
            }
            let parentElement = hash.parentNode.parentNode.querySelector('.title-list__item__body');
            if (parentElement) {
                parentElement.style.display = 'block';
                parentElement.parentNode.style.display = 'block';
            }
            

        }

        let typingTimer;
        let doneTypingInterval = 1200;
        let search = el.querySelector('#search');
        if (!search) {
            return;
        }
        search.addEventListener('keyup', () => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(function () {
                fetch('?' + search.id + '=' + (search.value ? search.value : '*'))
                    .then(function (response) {
                        if (response.ok) {
                            return response.text();
                        }
                        return Promise.reject(response);
                    })
                    .then(function (html) {
                        el.querySelector('.accordion').innerHTML = html;
                    })
                    .catch(function (error) {
                        console.warn(error);
                    });
            }, doneTypingInterval);
        });
    }
}

export default GuidanceList;
